import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { nodeStoreSelector } from '../node.selector';

export const nodeNamesSelector = createCachedSelector(
  [
    path(nodeStoreSelector).list(),
  ],
  (nodeList) => new Set(nodeList.map((node) => node.name)),
)({
  keySelector: defaultKeySelector,
});
